<!--<p>
  <span tooltip="Hello there! I was triggered manually"
        triggers="" #pop="bs-tooltip">
  This text has attached tooltip

  </span>
</p>-->
<div class="point {{ point?.state }} {{ (selectable || point.state == mapPointState.SELECTED) ? '' : 'not-selectable' }}" (click)="selected()"></div>